export class EntidadeEsfera {

  constructor(id: number) {
    this.id = id;
  }

  id: number;
  nome: string;
}
